import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgAddFile = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M4.158 4.68A4.68 4.68 0 0 1 8.838 0h9.199a4.681 4.681 0 0 1 3.437 1.504l5.125 5.544c.8.865 1.243 2 1.243 3.177V27.32a4.681 4.681 0 0 1-4.68 4.68H8.838a4.681 4.681 0 0 1-4.681-4.68zM19.95 8.263V3.278l5.308 4.984zm1.89 10.108h-4.707V13.48h-1.589v4.891H10.86v1.578h4.685v4.868h1.588v-4.868h4.708z" clipRule="evenodd" /></svg>;
export default SvgAddFile;